import React, {Component} from 'react'

import {PaymentForm} from '../components/PaymentForm'
import {Elements} from '@stripe/react-stripe-js'
import {loadStripe} from '@stripe/stripe-js'
import {Header} from "../components/Header";
import {Container, StyledMedia} from "../styles/CommonStyler"
import Footer from "../components/Footer";
import {isMobileOnly} from "react-device-detect";


// COMPONENT ##########################################################

const stripePromise = loadStripe(process.env.RAZZLE_STRIPE_KEY);

class Payment extends Component {

    render() {
        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>

                    <Header />

                        <Elements stripe={stripePromise}>
                            <PaymentForm />
                        </Elements>

                    <Footer />

                </Container>
            </StyledMedia>
        )
    }
}

export default Payment;
